import { useNavigate } from "react-router-dom";

import Style from "./style";

import DefaultButton from "shared/ui/DefaultButton";

import BackBtn from "./asset/back.svg";
import ReEntryButton from "page/ui/EventParticipantList/ui/ReEntryButton";

const MainHeader = ({
  children,
  btnList,
  reEntryBtn,
  reEntryList,
  showBackBtn = true,
}) => {
  const navigate = useNavigate();

  return (
    <Style.Wrapper>
      {children ? (
        <h2>{children}</h2>
      ) : (
        <>
          {showBackBtn ? (
            <Style.BackBtn onClick={() => navigate(-1)}>
              <img src={BackBtn} />
              뒤로가기
            </Style.BackBtn>
          ) : (
            <div />
          )}
        </>
      )}

      <Style.BtnDiv>
        {btnList?.map((elem) => (
          <DefaultButton
            fitWidth
            small
            deactive={elem?.deactive}
            clickEvent={elem?.clickEvent}
          >
            {elem.label}
          </DefaultButton>
        ))}

        {reEntryBtn && reEntryList && (
          <>
            <ReEntryButton
              label="리엔트리 +"
              type="increase"
              reEntryList={reEntryList}
            />
            <ReEntryButton
              label="리엔트리 -"
              type="decrease"
              reEntryList={reEntryList}
            />
          </>
        )}
      </Style.BtnDiv>
    </Style.Wrapper>
  );
};

export default MainHeader;
